<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span id="dlgCategoryTitle" class="title dialog-title">{{ title }}</span>
      <button
        id="dlgCategoryClose"
        mat-icon-button
        class="mat-icon-button white-fg"
        (click)="dialogRef.close()"
        aria-label="Close dialog"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <div
    mat-dialog-content
    class="p-24 m-0"
    fxLayout="column"
    fxLayoutAlign="start start"
    fusePerfectScrollbar
  >
    <app-check-list
      class="py-8 w-100-p"
      [list]="selectAllList"
      [multiselect]="false"
      [readOnly]="readOnly"
      (onChanged)="selectAllChanged($event)"
    ></app-check-list>
    <mat-divider class="px-16 w-100-p"></mat-divider>
    <app-check-list
      class="py-8 w-100-p"
      [list]="fullNameList"
      [multiselect]="true"
      (onChanged)="nameChanged($event)"
    >
    </app-check-list>
  </div>

  <!-- <div mat-dialog-content-class="p-24 m-0" fusePerfectScrollbar>
      <div class="pb-24">
        {{ intro }}
        <form
          class="addDialog"
          [formGroup]="emailPrompt"
          fxLayout="column"
          fxFlex
        ></form>
      </div>
    </div> -->
  <div mat-dialog-actions class="m-0 p-24" fxLayout="row">
    <button
      mat-raised-button
      class="mat-accent"
      (click)="confirmEmail()"
      [mat-dialog-close]="1"
      [disabled]="this.disabled"
    >
      SEND EMAIL
    </button>
  </div>
</div>
